import { keys } from '../../query/keyRegistry';

export const calendarKeys = {
  month: (customer_id: number, month_ym: string) => keys.customer(customer_id).calendar(month_ym),
  scope: (customer_id: number) => keys.customer(customer_id).calendarAll,
};
